// extracted by mini-css-extract-plugin
module.exports = {"efPicture":"EFPicture_efPicture__h4t7e"};